import { useMemo } from "react";

const ElementClass: Record<number, string> = {
  0: "fire",
  1: "water",
  2: "air",
  3: "earth",
};

interface Props {
  element: number | undefined;
}

// Fixed full-screen layer rendered behind everything. Paints an elemental
// glow + a thin layer of animated particles that match the player's
// element. Pure CSS — no images, cheap to render.
export function ElementalBackdrop({ element }: Props) {
  const cls = element != null ? ElementClass[element] : "";

  // Generate the particle positions deterministically per mount.
  const particles = useMemo(() => {
    const count = cls === "air" ? 18 : 26;
    return Array.from({ length: count }).map((_, i) => {
      const left = Math.random() * 100;
      const size =
        cls === "earth"
          ? Math.random() * 4 + 3
          : cls === "water"
          ? Math.random() * 6 + 4
          : Math.random() * 3 + 2;
      const delay = Math.random() * 18;
      const duration =
        cls === "earth" ? 22 + Math.random() * 8 :
        cls === "water" ? 16 + Math.random() * 6 :
        cls === "air"   ? 14 + Math.random() * 6 :
                          10 + Math.random() * 4;
      return {
        key: i,
        left: `${left}vw`,
        size,
        delay,
        duration,
      };
    });
  }, [cls]);

  return (
    <>
      <div className="elemental-backdrop" aria-hidden />
      {cls && (
        <div className={`elemental-particles ${cls}`} aria-hidden>
          {particles.map((p) => (
            <span
              key={p.key}
              style={{
                left: p.left,
                width: `${p.size}px`,
                height: `${p.size}px`,
                animationDelay: `-${p.delay}s`,
                animationDuration: `${p.duration}s`,
              }}
            />
          ))}
        </div>
      )}
    </>
  );
}
